import DatabaseModel from './DatabaseModelOffline.js';

var Pais = Object.create(DatabaseModel);

Pais.model = 'paises';

export default Pais;